import { StateNode } from '@ansys-internal/awf-angular/store';
import { AWCTreeItem } from '@ansys-internal/awc-angular/trees';

export class RequirementItemState implements StateNode<AWCTreeItem[]> {
  key: string = 'requirements';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => AWCTreeItem[] = () => [];
}
